import * as React from 'react'

export default () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 7C20.9706 7 25 11.0294 25 16C25 20.9706 20.9706 25 16 25C11.0294 25 7 20.9706 7 16C7 11.0294 11.0294 7 16 7ZM21.625 16.5625C21.625 16.5625 19.5 17.5625 16 17.5625C12.5 17.5625 10.375 16.5625 10.375 16.5625C10.375 19.6691 12.8934 22.1875 16 22.1875C19.1066 22.1875 21.625 19.6691 21.625 16.5625ZM12.0625 11.5C11.1305 11.5 10.375 12.2555 10.375 13.1875C10.375 14.1195 11.1305 14.875 12.0625 14.875C12.9945 14.875 13.75 14.1195 13.75 13.1875C13.75 12.2555 12.9945 11.5 12.0625 11.5ZM19.9375 11.5C19.0055 11.5 18.25 12.2555 18.25 13.1875C18.25 14.1195 19.0055 14.875 19.9375 14.875C20.8695 14.875 21.625 14.1195 21.625 13.1875C21.625 12.2555 20.8695 11.5 19.9375 11.5Z"
      fill="#8FB4FF"
    />
  </svg>
)
